"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullSerialiser = void 0;
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.NullSerialiser = {
    read: function () { return null; },
    write: function () { }
};
